export default __webpack_public_path__ + "static/media/help.a5226826.svg";